import { render, staticRenderFns } from "./AddConfiguration.vue?vue&type=template&id=204a758e&scoped=true"
import script from "./AddConfiguration.vue?vue&type=script&lang=js"
export * from "./AddConfiguration.vue?vue&type=script&lang=js"
import style0 from "./AddConfiguration.vue?vue&type=style&index=0&id=204a758e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204a758e",
  null
  
)

export default component.exports